import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import notify from 'devextreme/ui/notify';
import { DynamicLayoutComponent } from '../dynamic-layout/dynamic-layout.component';

@Component({
  selector: 'app-dynamic-grouped-layout',
  templateUrl: './dynamic-grouped-layout.component.html',
  styleUrls: ['./dynamic-grouped-layout.component.css']
})
export class DynamicGroupedLayoutComponent implements OnInit {

  tileRows: any[] = null;
  dynamicLayoutDataSource: (dynamicLayoutId: number) => Observable<any> = null;

  constructor() { }

  ngOnInit() {
  }

  @Input()
  set dynamicLayout(dynamicData: Observable<any>) {
    if (dynamicData != null && typeof (dynamicData.subscribe) === "function") {
      this.tileRows = null;
      dynamicData.subscribe((result: any) => {
        if (result.IsSuccess && result.Data.Tiles != null && result.Data.Tiles.length > 0) {
          var trs = [];
          this.tileRows = DynamicLayoutComponent.getTiles(result.Data);
        }
        else {
          notify(result.ErrorMessage, 'error', 500);
        }
      }, error => {

      });
    }
    else if (dynamicData != null) {
      var dd = dynamicData as any;
      if (this.tileRows == null
        || this.tileRows.length != 1
        || this.tileRows.length > 0 && this.tileRows[0].tiles.length != 1
        || this.tileRows[0].tiles[0].DynamicLayoutId != dd.DynamicLayoutId) {
        this.tileRows = DynamicLayoutComponent.getTiles(dd);
      }
      else {
        if (this.tileRows.length == 1 && this.tileRows[0].tiles.length == 1 && typeof (this.tileRows[0].tiles[0].refreshGrid) === "function") {
          //BEA 2022-02-23 quick and dirty way to force the grid to reload without repainting the whole component (and losing any user grouping collaps/expand)
          this.tileRows[0].tiles[0].refreshGrid();
        }
      }
    }
  }

  @Input()
  set tileDataSource(dlds: (dynamicLayoutId: number) => Observable<any>) {
    this.dynamicLayoutDataSource = dlds;
  }
}
